import {ValueObject} from '@s-ui/domain'

export default class UserProfileNotificationsValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {Bool} deps.isPortalAnnoucementsShowed
   */
}
